export default {
  common: {
    account: '帳戶',
    myPage: '我的主頁',
    booking: '訂單記錄',
    logout: '退出登入',
    save: '儲存',
    colon: '：',
    multiply: '×',
    next: '下一步',
    return: '返回',
    toPay: '前往付款',
    update: '更新',
    search: '搜尋',
    space: ' ',
    add: '添加',
    confirm: '確認',
    cancel: '取消',
    searchPlaceholder: '搜尋...',
    tilde: '~',
    showMore: '更多'
  },
  price: {
    primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
    jpyWord: 'JPY',
    jpySymbol: '¥'
  },
  footer: {
    terms: '使用條款',
    cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
    copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.'
  },
  validation: {
    required: '{{field}}為必填項',
    invalid: '請輸入有效的{{field}}',
    password: '請輸入至少8個字元，包含大寫字母、小寫字母、符號和數字',
    imageType: '請選擇圖片檔案',
    fileSize: '請選擇小於{{size}}MB的檔案',
    range: '請輸入{{min}}到{{max}}之間的值',
    requiredSelect: '請選擇{{field}}選項',
    emailNotMatch: '電郵地址不一致',
    emailAlreadyRegistered: '該電郵地址已註冊，請先通過登入按鈕進行登入。'
  },
  firebase: {
    'auth/wrong-password': '帳戶名稱或密碼有誤。',
    'auth/user-not-found': '帳戶名稱或密碼有誤。',
    'auth/email-already-in-use': '該E-mail信箱已被註冊。',
    'auth/too-many-requests': '登入失敗超過有限次數，煩請重設密碼或稍後再試。'
  },
  apiErrors: {
    baseError: '發生錯誤。',
    clientError: '發送API請求時發生客戶端錯誤。',
    serverError: '伺服器無法完成該請求。',
    connectionError: '連接伺服器失敗，煩請檢查您的網路設定並重新嘗試。',
    requestError: 'API請求發生錯誤。',
    ARSError: {
      AFFILIATE_ID_REQUIRED:
        '操作失敗，請回到原會員專屬首頁後再次進入商品頁重新嘗試。',
      BOOKING_NOT_ENOUGH_ALLOTMENT:
        '非常抱歉，由於所選日期/時間之庫存數量不足，煩請選擇其他日期/時間預訂。',
      BOOKING_NO_AVAILABILITY:
        '非常抱歉，由於所選日期/時間之庫存數量不足，煩請選擇其他日期/時間預訂。',
      PERMISSION_DENIED: '非常抱歉，您無權訪問該資源。',
      NOT_FOUND: '查無此資源。',
      BOOKING_ALREADY_ISSUED: '恕無法取消已兌換或使用的訂單。',
      BOOKING_RESERVATION_OVERLIMIT: '預訂數量已超出上限。'
    }
  },
  login: {
    title: '登入／註冊',
    caption: '請選擇登入、註冊會員的方式。',
    appleLogin: 'Apple',
    googleLogin: 'Google',
    email: '郵箱地址',
    emailConfirm: '郵箱地址（確認）',
    password: '密碼',
    button: '登入',
    forgotPassword: '忘記密碼？',
    newAccount: '註冊',
    signInAgree: `※可使用第三方帳戶輕鬆登入、註冊會員。\n ※當您使用E-mail或第三方帳戶登入時，將視同您已同意相關 <TermsLink>{{terms}}</TermsLink> 與 <PrivacyLink>{{privacy}}</PrivacyLink> 。`
  },
  password: {
    changePassword: '變更密碼',
    resetPassword: '重設密碼',
    sendResetEmail: '發送密碼重設郵件',
    sendResetEmailSuccess:
      '已將密碼重設連結發送至{{email}}，煩請確認並重新設定密碼。',
    oldPassword: '原密碼',
    newPassword: '新密碼',
    changePasswordSuccess: '密碼已成功變更。'
  },
  date: {
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六'
  },
  profile: {
    title: '個人資料',
    firstName: '名（請輸入半形英數字）',
    lastName: '姓（請輸入半形英數字）',
    email: '電郵地址',
    confirmEmail: '電郵地址（確認）',
    password: '密碼',
    gender: '性別',
    birthday: '出生日期',
    country: '國家',
    prefecture: '省份',
    genderOptions: {
      male: '男性',
      female: '女性',
      other: '其他'
    },
    updateProfileSuccess: '個人資料更新成功',
    updateProfileFailed: '個人資料更新失敗, 請稍後重試'
  },
  weeks: {
    sun: '日',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土'
  },
  empty: {
    message: '沒有內容'
  }
};
